import { render } from "./edit_room_drawer.vue?vue&type=template&id=2bb289b6&ts=true"
import script from "./edit_room_drawer.vue?vue&type=script&lang=ts"
export * from "./edit_room_drawer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__